export default __webpack_public_path__ + "static/media/mvboli.d879210b.ttf";